import React from 'react';

export const App = () => {
  return (
    <div>
      <h1>WELCOME TO LAGOS PURCHASE ORDERS</h1>
      <em>served with love via Module Federation</em>
      <div>
        <img src="https://media1.tenor.com/m/i64G1A4w6ZMAAAAC/spongebob-conch.gif" />
      </div>
    </div>
  );
};
